<template>
    <div>
        <el-form :model="form" :rules="rules" ref="form"  class="studentQues content" label-position="left"  >
            <div class="main_box">
                <p class="question_title">学生基本信息</p>
                <div class="main" style="padding-bottom: 51px">
                    <el-row type="flex"  justify="space-between">
                        <el-col :span="10" >
                            <el-form-item label="姓名：" prop="name" label-width="95px">
                                <el-input :value="form.name" readonly disabled></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="10">
                            <el-form-item label="性别：" prop="sex" label-width="95px">
                                <el-radio-group :value="form.sex" readonly disabled>
                                    <el-radio :label="1" >男</el-radio>
                                    <el-radio :label="2">女</el-radio>
                                </el-radio-group>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row type="flex"  justify="space-between">
                        <el-col :span="10" >
                            <el-form-item label="民族：" prop="nation" label-width="95px">
                                <el-input v-model="form.nation" maxLength='25' ></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="10">
                            <el-form-item label="籍贯：" prop="hometown" label-width="95px">
                                <el-input v-model="form.hometown" ></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row type="flex"  justify="space-between">
                        <el-col :span="10" >
                            <el-form-item label="高考年份：" prop="gaoYear" label-width="95px">
                                <el-select :value="form.gaoYear" placeholder="请选择高考年份" :disabled="true">
                                    <el-option v-for="(item,index) in yearArr" :label="getLabelYear(item,index)" :value="item" :key="index"></el-option>
                                </el-select>
                            </el-form-item>

                        </el-col>
                        <el-col :span="10">
                            <el-form-item label="高考省份：" prop="province" label-width="95px">
                                <el-select v-model="form.province" placeholder="请选择高考省份" :disabled="true" >
                                    <el-option v-for="(item,index) in provinceList" :label="item" :value="item" :key="index"></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                    </el-row>

                    <el-form-item label="高考科类：" prop="subject" label-width="95px">
                        <el-checkbox-group v-model="form.subject" :max="3">
                            <el-checkbox v-for="(item,index) in getSubjectList" :label="item" name="subject" :key="index" ></el-checkbox>
                        </el-checkbox-group>
                    </el-form-item>

                    <el-row type="flex"  justify="space-between">
                        <el-col :span="10" >
                            <el-form-item prop="birth" label="出生年月" label-width="95px">
                                <el-date-picker type="date" placeholder="选择日期" v-model="form.birth"  format="yyyy 年 MM 月 dd 日"
                                                value-format="yyyy-MM-dd"> style="width: 100%;"></el-date-picker>
                            </el-form-item>
                        </el-col>
                        <el-col :span="10">
                            <el-form-item label="学校：" prop="school" label-width="95px">
                                <el-input v-model="form.school" :disabled="true"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>

                    <el-row type="flex"  justify="space-between">
                        <el-col :span="10" >
                            <el-form-item label="班级：" prop="class" label-width="95px">
                                <el-input v-model="form.class" ></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="10">
                            <el-form-item label="班级职务：" prop="classPosition" label-width="95px">
                                <el-input v-model="form.classPosition" ></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>


                    <el-row type="flex"  justify="space-between">
                        <el-col :span="10" >
                            <el-form-item label="是否住校：" prop="inSchool" label-width="95px">
                                <el-radio-group v-model="form.inSchool">
                                    <el-radio label="是"></el-radio>
                                    <el-radio label="否"></el-radio>
                                </el-radio-group>
                            </el-form-item>
                        </el-col>
                        <el-col :span="10">
                            <el-form-item label="家庭住址：" prop="homeAddress" label-width="95px">
                                <el-input v-model="form.homeAddress" ></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </div>
            </div>
            <div class="main_box">
                <p class="question_title">家长基本信息</p>
                <div class="main">
                    <el-row type="flex"  justify="space-between">
                        <el-col :span="10" >
                            <el-form-item label="母亲姓名：" prop="motherName" label-width="95px">
                                <el-input v-model="form.motherName"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="10">
                            <el-form-item label="工作单位：" prop="motherWork" label-width="95px">
                                <el-input v-model="form.motherWork"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row type="flex"  justify="space-between">
                        <el-col :span="10" >
                            <el-form-item label="职务：" prop="motherPost" label-width="95px">
                                <el-input v-model="form.motherPost"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="10">
                            <el-form-item label="学历：" prop="motherEducation" label-width="95px">
                                <el-input v-model="form.motherEducation"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row type="flex">
                        <el-col :span="10">
                            <el-form-item label="联系方式：" prop="motherPhone" label-width="95px">
                                <el-input v-model="form.motherPhone"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row type="flex"  justify="space-between">
                        <el-col :span="10" >
                            <el-form-item label="父亲姓名：" prop="fatherName" label-width="95px">
                                <el-input v-model="form.fatherName"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="10">
                            <el-form-item label="工作单位：" prop="fatherWork" label-width="95px">
                                <el-input v-model="form.fatherWork"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row type="flex"  justify="space-between">
                        <el-col :span="10" >
                            <el-form-item label="职务：" prop="fatherPost" label-width="95px">
                                <el-input v-model="form.fatherPost"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="10">
                            <el-form-item label="学历：" prop="fatherEducation" label-width="95px">
                                <el-input v-model="form.fatherEducation"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row type="flex">
                        <el-col :span="10">
                            <el-form-item label="联系方式：" prop="fatherPhone" label-width="95px">
                                <el-input v-model="form.fatherPhone"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-form-item label="备注：" prop="remarks" label-width="95px">
                        <el-input type="textarea" v-model="form.remarks" maxLength={100} ></el-input>
                    </el-form-item>
                </div>
            </div>
            <div class="main_box">
                <p class="question_title">学习现状部分</p>
                <div class="main">
                    <el-form-item label="你给自己制定学习目标了吗，如何看待你的目标？" prop="learningGoal" class="labelBlock">
                        <el-input type="textarea" v-model="form.learningGoal" maxLength={100} ></el-input>
                    </el-form-item>
                    <el-form-item label="你能自己安排的时间有哪些？比如自习时间，会怎么分配时间？" prop="learningTime" class="labelBlock">
                        <el-input type="textarea" v-model="form.learningTime" maxLength={100} ></el-input>
                    </el-form-item>
                    <el-form-item label="你有制定学习计划的习惯吗，你会每天制定学习计划吗？" prop="learningPlan" class="labelBlock">
                        <el-input type="textarea" v-model="form.learningPlan" maxLength={100} ></el-input>
                    </el-form-item>
                    <el-form-item label="在记忆和背诵知识点方面你是否存在困扰？具体描述一下你的困扰。" prop="learningTrouble" class="labelBlock">
                        <el-input type="textarea" v-model="form.learningTrouble" maxLength={100} ></el-input>
                    </el-form-item>
                    <el-form-item label="预习情况：" prop="learningPreview" label-width="95px">
                        <el-radio-group v-model="form.learningPreview">
                            <el-radio v-for="(item,index) in ['不预习','偶尔预习','经常预习','一直预习']" :label="item" :key="index"></el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item label="课堂效果：" prop="learningClass" label-width="95px">
                        <el-radio-group v-model="form.learningClass">
                            <el-radio v-for="(item,index) in ['听不懂','听不太懂','基本听懂','完全听懂']" :label="item" :key="index"></el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item label="课堂笔记：" prop="learningNote" label-width="95px">
                        <el-radio-group v-model="form.learningNote">
                            <el-radio v-for="(item,index) in ['不做笔记','偶尔做笔记','经常做笔记','一直做笔记']" :label="item" :key="index"></el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item label="复习情况：" prop="learningReview" label-width="95px">
                        <el-radio-group v-model="form.learningReview">
                            <el-radio v-for="(item,index) in ['不复习','偶尔复习','经常复习','一直复习']" :label="item" :key="index"></el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item label="每天的作业练习，遇到不懂的译文，你是当天一定要想办法解决掉，还是以后再说？" prop="learningHomework"  class="labelBlock">
                        <el-radio-group v-model="form.learningHomework">
                            <el-radio v-for="(item,index) in ['从不','偶尔解决','经常解决','一定解决']" :label="item" :key="index"></el-radio>
                        </el-radio-group>
                    </el-form-item>

                    <el-form-item label="你会定期梳理所学知识，并进行总结和归纳吗，你认为自己的总结归纳能力如何？" prop="learningArrange" class="labelBlock">
                        <el-input type="textarea" v-model="form.learningArrange" maxLength={100} ></el-input>
                    </el-form-item>
                    <el-form-item label="你有整理错题的习惯吗？你是如何整理错题的？" prop="learningWrong" class="labelBlock">
                        <el-input type="textarea" v-model="form.learningWrong" maxLength={100} ></el-input>
                    </el-form-item>

                    <el-form-item label="考试情况：" prop="learningExam" label-width="95px">
                        <el-radio-group v-model="form.learningExam">
                            <el-radio v-for="(item,index) in ['总紧张','偶尔紧张','很少紧张','轻松应考']" :label="item" :key="index"></el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item label="学习成绩：" prop="learningGrade" label-width="95px">
                        <el-radio-group v-model="form.learningGrade">
                            <el-radio v-for="(item,index) in ['波动大','有些波动','比较稳定','十分稳定']" :label="item" :key="index"></el-radio>
                        </el-radio-group>
                    </el-form-item>

                    <p class="p_title">最新一次考试成绩是</p>
                    <el-row type="flex" :gutter="30" >
                        <el-col :span="8" >
                            <el-form-item label="学期：" prop="learningTerm" >
                                <el-select v-model="form.learningTerm" placeholder="请选择">
                                    <el-option v-for="(item,index) in ['初一上','初一下','初二上','初二下','初三上','初三下','中考','高一上','高一下','高二上','高二下','高三上','高三下',]" :label="item" :value="item" :key="index"></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8" >
                            <el-form-item label="考试：" prop="learningYuekao">
                                <el-select v-model="form.learningYuekao" placeholder="请选择">
                                    <el-option v-for="(item,index) in ['第一次月考','第二次月考','第三次月考','第四次月考']" :label="item" :value="item" :key="index"></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item  label="年级人数" prop="learningYearPeople">
                                <el-input type="number" v-model="form.learningYearPeople" maxLength={25} placeholder="请输入年级人数"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <div class="table_box">
                        <table>
                            <thead>
                                <tr>
                                    <th width="150">学科</th>
                                    <th>分数</th>
                                    <th>年级排名</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr key={index} v-for="(item,index) in form.learningGradeArr" :key="index">
                                    <th>{{item.subject}}</th>
                                    <td><el-input type="number" v-model="form.learningGradeArr[index].grade" maxLength={25} placeholder="请输入分数"></el-input></td>
                                    <td><el-input type="number" v-model="form.learningGradeArr[index].rank" maxLength={25} placeholder="请输入年级排名"></el-input></td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <p class="p_title">
                        在语文、数学、外语、物理、化学、生物、历史、政治、地理九门学科中，
                    </p>
                    <el-form-item  label="我对各学科的喜爱程度：" class="line_select" label-width="200px">
                        <div v-for="(item,index) in allSubjects" :key="index" class="select_box">
                            <span v-show="index!=0">&gt;</span>
                            <el-select v-model="form.learningLikeRank[index]" placeholder=" ">
                                <el-option v-for="(i,idx) in allSubjects" :label="i" :value="i" :key="idx" :disabled="form.learningLikeRank.some(value=>value==i)"></el-option>
                            </el-select>
                        </div>
                    </el-form-item>
                    <el-form-item  label="我对各学科的擅长程度：" class="line_select" label-width="200px">
                        <div v-for="(item,index) in allSubjects" :key="index" class="select_box">
                            <span v-show="index!=0">&gt;</span>
                            <el-select v-model="form.learningGoodRank[index]" placeholder=" ">
                                <el-option v-for="(i,idx) in allSubjects" :label="i" :value="i" :key="idx" :disabled="form.learningGoodRank.some(value=>value==i)"></el-option>
                            </el-select>
                        </div>
                    </el-form-item>
                    <el-form-item  label="我对各学科教师的喜爱程度：" class="line_select" label-width="200px">
                        <div v-for="(item,index) in allSubjects" :key="index" class="select_box">
                            <span v-show="index!=0">&gt;</span>
                            <el-select v-model="form.learningTeacherRank[index]" placeholder=" ">
                                <el-option v-for="(i,idx) in allSubjects" :label="i" :value="i" :key="idx" :disabled="form.learningTeacherRank.some(value=>value==i)"></el-option>
                            </el-select>
                        </div>
                    </el-form-item>
                </div>
            </div>
            <div class="main_box">
                <p class="question_title">学习动力部分</p>
                <div class="main">
                    <el-form-item label="对我来说，学习过程中的动力有什么？" prop="learningPower" class="labelBlock">
                        <el-input type="textarea" v-model="form.learningPower" maxLength={200} ></el-input>
                    </el-form-item>
                    <el-form-item label="你喜欢学习吗，在学习过程中你的感受是怎样的？描述一下你的感受。" prop="learningFeel" class="labelBlock">
                        <el-input type="textarea" v-model="form.learningFeel" maxLength={200} ></el-input>
                    </el-form-item>
                    <el-form-item label="对我来说，学习过程中的阻碍有什么：" prop="learningHinder" class="labelBlock">
                        <el-input type="textarea" v-model="form.learningHinder" maxLength={200} ></el-input>
                    </el-form-item>
                    <el-form-item label="其中最大的阻碍是：" prop="learningMaxHinder" class="labelBlock">
                        <el-input type="textarea" v-model="form.learningMaxHinder" maxLength={200} ></el-input>
                    </el-form-item>
                    <el-form-item label="我认为这种矛盾可以解决的程度是：" prop="learningSolveHinder">
                        <el-radio-group v-model="form.learningSolveHinder">
                            <el-radio v-for="(item,index) in ['非常容易','容易','一般','困难','非常困难']" :label="item" :key="index"></el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item label="理由：" prop="learningSolveLiyou">
                        <el-input v-model="form.learningSolveLiyou" maxLength={70} ></el-input>
                    </el-form-item>

                    <el-form-item label="我认为自己的信息发展潜力如何：" prop="learningPotential">
                        <el-radio-group v-model="form.learningPotential">
                            <el-radio v-for="(item,index) in ['很有潜力','有潜力','没潜力','不确定']" :label="item" :key="index"></el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item label="理由：" prop="learningPotentialLiyou">
                        <el-input v-model="form.learningPotentialLiyou" maxLength={70} ></el-input>
                    </el-form-item>
                </div>
            </div>
            <div class="main_box">
                <p class="question_title">个人信息部分</p>
                <div class="main">
                    <el-form-item label="我参加的社团：" prop="myClub" label-width="125px">
                        <el-input v-model="form.myClub" maxLength={70} ></el-input>
                    </el-form-item>
                    <el-form-item label="我的兴趣爱好：" prop="myHobby" label-width="125px">
                        <el-input v-model="form.myHobby" maxLength={70} ></el-input>
                    </el-form-item>
                    <el-form-item label="我的特长优势：" prop="mySpecialty" label-width="125px">
                        <el-input v-model="form.mySpecialty" maxLength={70} ></el-input>
                    </el-form-item>
                    <el-form-item label="我的缺点不足：" prop="myShortcomings" label-width="125px">
                        <el-input v-model="form.myShortcomings" maxLength={70} ></el-input>
                    </el-form-item>
                    <el-form-item label="我最好的朋友：" prop="myBestFriend" label-width="125px">
                        <el-input v-model="form.myBestFriend" maxLength={70} ></el-input>
                    </el-form-item>
                    <el-form-item label="喜欢的书：" prop="myLikeBook" label-width="125px" placeholder="（近期）">
                        <el-input v-model="form.myLikeBook" maxLength={70} ></el-input>
                    </el-form-item>
                    <el-form-item label="喜欢的电影：" prop="myLikeMovie" label-width="125px" placeholder="（近期）">
                        <el-input v-model="form.myLikeMovie" maxLength={70} ></el-input>
                    </el-form-item>
                    <el-form-item label="喜欢的明星：" prop="myLikeStar" label-width="125px" placeholder="（近期）">
                        <el-input v-model="form.myLikeStar" maxLength={70} ></el-input>
                    </el-form-item>
                    <el-form-item label="我的愿望：" prop="myWish" label-width="125px" placeholder="（近期）">
                        <el-input v-model="form.myWish" maxLength={70} ></el-input>
                    </el-form-item>



                    <el-form-item label="我向往的职业：" prop="myLikeCareer" label-width="125px" placeholder="以后想做的">
                        <el-input v-model="form.myLikeCareer" maxLength={70} ></el-input>
                    </el-form-item>
                    <el-form-item label="我向往的专业：" prop="myLikeMajor" label-width="125px" placeholder="以后想学的">
                        <el-input v-model="form.myLikeMajor" maxLength={70} ></el-input>
                    </el-form-item>
                    <el-form-item label="我向往的大学：" prop="myLikeUniversity" label-width="125px" placeholder="以后想去的">
                        <el-input v-model="form.myLikeUniversity" maxLength={70} ></el-input>
                    </el-form-item>



                    <el-form-item label="最近做过让自己很有成就感的事：" prop="myAccomplishment" class="labelBlock">
                        <el-input type="textarea" v-model="form.myAccomplishment" maxLength={200} ></el-input>
                    </el-form-item>
                    <el-form-item label="我最近的烦恼：" prop="myUpset" class="labelBlock">
                        <el-input type="textarea" v-model="form.myUpset" maxLength={200} ></el-input>
                    </el-form-item>
                    <el-form-item label="我未来想过的生活：" prop="myWantLife" class="labelBlock">
                        <el-input type="textarea" v-model="form.myWantLife" maxLength={200} ></el-input>
                    </el-form-item>

                </div>
            </div>
            <div class="main_box">
                <p class="question_title">个人成就部分</p>
                <div class="main">
                    <el-form-item label="是否曾经获得过市级及以上奖励（如三好学生，优秀干部等）" prop="isAwarded">
                        <el-radio-group v-model="form.isAwarded" @change="changeAward">
                            <el-radio v-for="(item,index) in ['有','无']" :label="item" :key="index"></el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-row type="flex"   v-for="(item,index) in form.awarded" :key="index" :gutter="20" v-show="form.isAwarded=='有'">
                        <el-col :span="10" >
                            <el-form-item label="奖励名称：">
                                <el-input v-model="form.awarded[index].name"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="6">
                            <el-form-item label="获奖年份：" >
                                <el-select v-model="form.awarded[index].year" placeholder=" ">
                                    <el-option  v-for="(itm,idx) in awardYearArr" :key="idx" :value="itm"></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8" >
                            <el-form-item label="获奖等级：">
                                <el-select v-model="form.awarded[index].grade" placeholder=" ">
                                    <el-option value="市级"></el-option>
                                    <el-option value="省级"></el-option>
                                    <el-option value="国家级"></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <div class="add_awarded" @click="this.addAward" v-show="form.isAwarded=='有'">+添加更多奖励</div>

                    <el-form-item label="是否对高考统招之外其他路径做过了解并有参与的意愿：" prop="isWantOtherWay">
                        <el-radio-group v-model="form.isWantOtherWay">
                            <el-radio v-for="(item,index) in ['有','无']" :label="item" :key="index"></el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item label="请选择：" prop="otherWayList" label-width="80px" v-show="form.isWantOtherWay==='有'">
                        <el-checkbox-group v-model="form.otherWayList">
                            <el-checkbox v-for="(item,index) in ['强基计划','综合评价','高校专项计划','高水平艺术团','高水平运动队','飞行员','其他']" :label="item" name="otherWayList" :key="index"></el-checkbox>
                        </el-checkbox-group>
                    </el-form-item>
                </div>
            </div>
            <div class="main_box">
                <p class="question_title">学业规划意图</p>
                <div class="main">
                    <el-form-item label="我认为科学、系统、完整的学习规划，对学习及个人发展有什么好处：" prop="studyWill" class="labelBlock">
                        <el-input type="textarea" v-model="form.studyWill" maxLength={200} ></el-input>
                    </el-form-item>
                </div>
            </div>
            <div class="main_box">
                <p class="question_title">其他部分</p>
                <div class="main" style="padding-bottom: 0px">
                    <el-form-item label="希望获得哪些方面的帮助：" prop="otherHelp" class="labelBlock">
                        <el-input type="textarea" v-model="form.otherHelp" maxLength={200} ></el-input>
                    </el-form-item>
                    <el-form-item label="其他说明：" prop="otherDescription" class="labelBlock">
                        <el-input type="textarea" v-model="form.otherDescription" maxLength={200} ></el-input>
                    </el-form-item>
                </div>
            </div>
        </el-form>
        <div class="btnBox" style="display: flex;justify-content: space-around;padding: 30px 0px;width: 300px;margin: 0px auto;">
            <Button @handleClick="submitForm('form')" :type="'btnGray'" name="保存" ></Button>
        </div>
        <!-- <StudentPopup v-show="isShowPopup"  @closePop="isShowPopup=false" :name="studentName"></StudentPopup> -->
    </div>
</template>

<script>
// import StudentPopup from './studentPopup.vue';
import Button from '@/components/Button.vue'
export default {
    name: "parentQues",
    components:{Button },
    data() {
        return {
            isShowPopup: false,
            isShowGuide: false,
            nowYear: new Date().getFullYear(),
            yearArr: [],
            awardYearArr: [],
            term: ['高一上','高一下','高二上','高二下','高三上','高三下'],
            yuekao: ['第一次月考','第二次月考','第三次月考','第四次月考'],
            allSubjects: ['语文','数学','外语','物理','化学','生物','历史','政治','地理'],
            censusQuestion: null,
            province: '山东',
            provinceList: [
                '北京','上海','天津','重庆','四川','贵州','云南','西藏','河南','湖北','湖南','广东','广西','陕西','甘肃','青海','宁夏','新疆','河北','山西','内蒙古','江苏','浙江','安徽','福建','江西','山东','辽宁','吉林','黑龙江','海南','台湾','香港','澳门'
            ],


            form: {
                name: '',//姓名
                sex: '',//性别 1男2女
                nation:'',//民族
                hometown: '',//籍贯
                gaoYear: 2020,//高考年份
                province: '',//省份
                subject: [],//高考科类
                birth: null,//出生年月
                school: '',//学校
                class: '',//班级
                stressClass: '',//重点班级 1是 2否
                classPosition: '',//班级职务
                inSchool: '',//是否住校 1走读 2住校
                homeAddress: '',//家庭住址
                grade: '',//高考年份对应的年级




                // 家庭基本信息
                motherName: '', //母亲姓名
                motherWork: '', //工作单位
                motherPost: '', //职务
                motherEducation: '', //学历
                motherPhone: '', //联系方式
                fatherName: '', //父亲姓名
                fatherWork: '', //工作单位
                fatherPost: '', //职务
                fatherEducation: '', //学历
                fatherPhone: '', //联系方式
                remarks: '', //备注



                //学习现状部分
                learningGoal: '',// 你给自己制定学习目标了吗，如何看待你的目标？
                learningTime: '',// 你能自己安排的时间有哪些？比如自习时间，会怎么分配时间？
                learningPlan: '',// 你有制定学习计划的习惯吗，你会每天制定学习计划吗？
                learningTrouble: '',// 在记忆和背诵知识点方面你是否存在困扰？具体描述一下你的困扰。

                learningPreview: '',// 预习情况
                learningClass: '',// 课堂效果
                learningNote: '',// 课堂笔记
                learningReview: '',// 复习情况
                learningHomework: '',// 每天的作业练习，遇到不懂的题目，你是当天一定要想办法解决掉，还是以后再说？
                learningArrange: '',// 你会定期梳理所学知识，并进行总结和归纳吗，你认为自己的总结归纳能力如何？
                learningWrong: '',// 你有整理错题的习惯吗？你是如何整理错题的？

                learningExam: '',// 考试情况
                learningGrade: '',// 学习成绩
                learningLookGoal: '',// 你给自己制定学习目标了吗，如何看待你的目标？
                learningTerm: '',//学期
                learningYuekao: '',//月考
                learningYearPeople: '',//人数
                learningGradeArr:[
                    { subject: '语文',grade: '', rank: ''},
                    { subject: '数学',grade: '', rank: ''},
                    { subject: '外语',grade: '', rank: ''},
                    { subject: '物理',grade: '', rank: ''},
                    { subject: '化学',grade: '', rank: ''},
                    { subject: '生物',grade: '', rank: ''},
                    { subject: '历史',grade: '', rank: ''},
                    { subject: '政治',grade: '', rank: ''},
                    { subject: '地理',grade: '', rank: ''}
                ],

                // learningLikeRank: Array(9).fill('')
                learningLikeRank: [],


                learningGoodRank:[],

                learningTeacherRank:[],

                // 学习动力部分
                learningPower: '',//对我来说，学习过程中的动力有什么？
                learningFeel: '',//你喜欢学习吗，在学习过程中你的感受是怎样的？描述一下你的感受
                learningHinder: '',//对我来说，学习过程中的阻碍有什么
                learningMaxHinder: '',//其中最大的阻碍是：
                learningSolveHinder: '',//我认为这种阻碍可以解决的程度是
                learningSolveLiyou: '',//我认为这种阻碍可以解决的程度是（理c由）
                learningPotential: '',//我认为自己的信息发展潜力如何
                learningPotentialLiyou: '',//我认为自己的信息发展潜力如何（理由）



                // 个人信息部分 my
                myClub: '',//我参加的社团
                myHobby: '',//我的兴趣爱好
                mySpecialty: '',//我的特长优势
                myShortcomings: '',//我的缺点不足
                myBestFriend: '',//我最好的朋友
                myLikeBook: '',//喜欢的书
                myLikeMovie: '',//喜欢的电影
                myLikeStar: '',//喜欢的明星
                myWish: '',//我的愿望
                myLikeCareer: '',//我向往的职业
                myLikeMajor: '',//我向往的专业
                myLikeUniversity: '',//我向往的大学
                myAccomplishment: '',//最近做过让自己很有成就感的事
                myUpset: '',//我最近的烦恼
                myWantLife: '',//我未来想过的生活


                // 个人成就部分
                isAwarded: '',
                awarded: [{
                    key: 1,
                    name: '',//获奖名称
                    year: '',//获奖年份
                    grade: ''//奖励级别
                }],
                isWantOtherWay: '',//是否对高考统招之外其他路径做过了解并有参与的意愿
                otherWayList: [],

                // 学业规划意愿
                studyWill: '',//我认为科学、系统、完整的学习规划，对学习及个人发展有什么好处：
                // 其他部分
                otherHelp: '',//希望获得哪些方面的帮助：
                otherDescription: '',//其他说明

            },
            rules: {
                name: [
                    {  required: true, message: '必填项不能为空', trigger: 'blur'}
                ],
                sex: [
                    { required: true, message: '必填项不能为空', trigger: 'blur' }
                ],
                nation: [
                    { required: true, message: '必填项不能为空', trigger: 'blur' }
                ],
                hometown: [
                    { required: true, message: '必填项不能为空', trigger: 'blur' }
                ],
                gaoYear: [
                    { required: true, message: '必填项不能为空' }
                ],
                province: [
                    { required: true, message: '必填项不能为空' }
                ],
                // subject: [
                //     { required: true, message: '必填项不能为空', trigger: 'change' }
                // ],
                birth: [
                    { type:'string',required: true, message: '必填项不能为空', trigger: 'change'}
                ],
                school: [
                    { required: true, message: '必填项不能为空', trigger: 'blur' }
                ],
                class: [
                    { required: true, message: '必填项不能为空', trigger: 'blur' }
                ],
                classPosition: [
                    { required: true, message: '必填项不能为空', trigger: 'blur'}
                ],
                inSchool: [
                    { required: true, message: '必填项不能为空', trigger: 'blur' }
                ],
                homeAddress: [
                    { required: true, message: '必填项不能为空', trigger: 'blur' }
                ],


                motherName: [
                    {  required: true, message: '必填项不能为空', trigger: 'blur'}
                ],
                motherWork: [
                    { required: true, message: '必填项不能为空', trigger: 'blur' }
                ],
                motherPost: [
                    { required: true, message: '必填项不能为空', trigger: 'blur' }
                ],
                motherEducation: [
                    { required: true, message: '必填项不能为空', trigger: 'blur' }
                ],
                motherPhone: [
                    { required: true, message: '必填项不能为空', trigger: 'blur' }
                ],
                fatherName: [
                    {  required: true, message: '必填项不能为空', trigger: 'blur'}
                ],
                fatherWork: [
                    { required: true, message: '必填项不能为空', trigger: 'blur' }
                ],
                fatherPost: [
                    { required: true, message: '必填项不能为空', trigger: 'blur' }
                ],
                fatherEducation: [
                    { required: true, message: '必填项不能为空', trigger: 'blur' }
                ],
                fatherPhone: [
                    { required: true, message: '必填项不能为空', trigger: 'blur' }
                ],
                remarks: [
                    { required: true, message: '必填项不能为空', trigger: 'blur' }
                ],




                

                
            }
        }
    },
    computed: {
        studentName(){
            return this.$store.state.user.name
        },
        getSubjectList() {
            if(this.province !='浙江') {
                return ['物理','化学','生物','历史','政治','地理'];
            }else {
                this.form.learningGradeArr.push({ subject: '技术',grade: '', rank: ''},)
                return ['物理','化学','生物','历史','政治','地理','技术']
            }
        }
    },
    methods: {
        changeAward(value) {
            if(value=='有') {
                this.form.awarded = [{
                    key: 0,
                    name: '',//获奖名称
                    year: '',//获奖年份
                    grade: ''//奖励级别
                }];
            }else {
                this.form.awarded = [];
            }
        },
        addAward() {
            let length = this.form.awarded.length;
            this.form.awarded.push({
                key: length,
                name: '',//获奖名称
                year: '',//获奖年份
                grade: ''//奖励级别
            });
        },
        getAllSubject() {
            if(this.province !='浙江') {
                this.allSubjects = ['语文','数学','外语','物理','化学','生物','历史','政治','地理'];
            }else {
                this.allSubjects = ['语文','数学','外语','物理','化学','生物','历史','政治','地理','技术'];
            }
        },
        getLabelYear(item,index) {
            if(index == 0) {
                return item + ' (高三)';
            }else if(index == 1) {
                return item + ' (高二)';
            }else if(index == 2) {
                return item + ' (高一)';
            }else if(index == 3) {
              return item + ' (初三)';
            }else if(index == 4) {
              return item + ' (初二)';
            }else if(index == 5) {
              return item + ' (初一)';
            }else {
                return item;
            }
        },
        validate() {
            // console.log(5555)
        },
        changSelect(e) {
            // console.log(this.form)
        },

        changeArr() {
            let date = new Date();
            let nowYear = date.getFullYear();
            let nowMonth = date.getMonth();
            if(nowMonth>=7) {
                nowYear+=1;
            }
            let i = nowYear;
            let j = nowYear-6;
            let arr1 = [];
            let arr2 = [];
            while(i < nowYear + 6) {
                arr1.push(i);
                i ++;
            }
            while(j < nowYear) {
                j ++;
                arr2.push(j);
            }
            this.yearArr = arr1;
            this.awardYearArr = arr2;
        },
        submitForm(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.storeStudentCensusQuestion();
                } else {
                    setTimeout(()=>{
                        let isError= document.getElementsByClassName("is-error");
                        let top = isError[0].offsetTop;     //获取元素到页面最顶点的高度（不会随着页面滚动变化的高度）
                        window.scrollTo(0,top-80);
                    },100);
                    return false;
                }
            });
        },
        storeStudentCensusQuestion() {
            
            // e.preventDefault();
            let data = this.form;
            let date = new Date();
            let nowYear = date.getFullYear();
            let nowMonth = date.getMonth();
            let year = nowYear - data.gaoYear;
            let grade;

            if(year === 0) {
                grade = '高三';
            } else if(year === 1) {
                if(nowMonth < 8) {
                    grade = '高二';
                }else {
                    grade = '高三';
                }
            } else {
                if(nowMonth < 8) {
                    grade = '高一';
                }else {
                    grade = '高二';
                }
            }
            data.grade = grade;
            const params = {
                // name: data.name,
                // sex: data.sex,
                nation: data.nation,
                hometown: data.hometown,
                // gaoYear: data.gaoYear,
                // province: data.province,
                subject: data.subject,
                birth: data.birth,
                // school: data.school,
                class: data.class,
                stressClass: data.stressClass,
                classPosition: data.classPosition,
                inSchool: data.inSchool,
                homeAddress: data.homeAddress,
                grade: grade,
                status: 2,
                censusQuestion: data
            }
            // console.log(params);
            this.$ajax.post(this.G_acapi+this.ports.student.message.storeNotFirstStudentCensusQuestion,params,{
                headers:{
                    token: window.sessionStorage.getItem('ymtxToken')
                }
            }).then((res)=>{
                if(res.data.code==2000){

                    // this.$router.push('/studyPlan/studentQuesMessageDetail')
                    this.detailStudentCensusQuestion();
                    if(res.data.code==2000){
                    this.$message({
                        message: '保存成功',
                        type: 'success'
                    });
                    this.isShowBtn = false;
                    this.$store.commit('getStudentStatus',3);                   
                    document.body.scrollIntoView();
                    }
                }else{
                    this.$message({
                            message: res.data.msg,
                            type: 'error'
                        });
                }
            })
        },
        detailStudentCensusQuestion() {
            this.$ajax.post(this.G_acapi+this.ports.student.message.detailStudentCensusQuestion,{
            },{
                headers:{
                    token: window.sessionStorage.getItem('ymtxToken')
                }
            }).then((res)=>{
                if(res.data.code==2000){
                    this.isShowBtn = true;
                    let data = res.data.data;
                    let censusQuestion = data.censusQuestion;
                    if(data.status==1) {
                        this.isShowPopup = true;
                    }
                    if(censusQuestion) {
                        this.form = censusQuestion;
                    }else {
                        let form = this.form;
                        form.gaoYear = data.gaoYear;
                        form.name = data.name;
                        form.school = data.schoolName;
                        form.sex = data.sex;
                        this.form = form;
                    }
                }else{
                    this.$message({
                            message: res.data.msg,
                            type: 'error'
                        });
                }
            })
        }
    },

    watch: {
    },
    created() {
        this.getAllSubject();
        this.changeArr();
        this.detailStudentCensusQuestion();
    },
    mounted() {
    }
}
</script>

<style scoped lang="less">
.studentQues {
    background-color: #fff;
    //margin-left: 20px;
    padding: 30px;
    font-size: 16px;
    .question_title {
        width: 200px;
        height: 40px;
        line-height: 40px;
        padding-left: 30px;
        color: #fff;
        font-size: 18px;
        background-color: #00A4FA;
        position: relative;
        &:after {
            content: '';
            position: absolute;
            right: -30px;
            bottom: 0;
            width: 0;
            height: 0;
            border-width: 0px 30px 40px 30px;
            border-style: solid;
            border-color: transparent transparent #fff transparent;
        }
    }
    .main_box {
        .main {
            padding: 20px 0 50px 30px;
        }
    }
    .table_box {
        padding: 10px 0;
        table {
            width: 100%;
            thead {
                th {
                    background: rgba(61, 144, 246, 0.2);
                    font-size: 16px;
                    line-height: 40px;
                    text-align: center;
                    border: 1px solid rgba(61, 144, 246, 0.4);
                }
            }
            tbody {
                tr {
                    line-height: 40px;
                    th {
                        font-size: 16px;
                        text-align: center;
                        background: #FAFDFF;
                        border: 1px solid rgba(61, 144, 246, 0.4);
                    }
                    td {
                        border: 1px solid #EDEDED;

                    }

                }
            }
            input {
                border: none;
                background-color: #fff;
            }

        }
    }
    .add_awarded {
        line-height: 40px;
        background-color: #f0f9fe;
        border: 1px dotted #cdedff;
        text-align: center;
        cursor: pointer;
        color: #0393ea;
        margin-bottom: 20px;
    }
}
</style>
<style lang="less">
.studentQues {
    font-size: 16px;
    input {
        border: 1px solid #EAEAEA;
        background-color: #FDFDFD;
    }
    .p_title {
        line-height: 40px;
        margin-bottom: 10px;
    }
    .el-select {
        width: 100%;
    }
    .el-form-item {
        display: flex;
        flex-wrap: wrap;
    }
    .el-form-item__content {
        margin-left: 0 !important;
        flex: 1;
    }
    .student_study {
        .el-form-item {
            margin-bottom: 5px;
            .el-radio__label {
                display: inline-block;
                width: 85px;
            }
            .el-checkbox {
                height: 30px;
                line-height: 30px;
            }
            .el-checkbox__label {
                width: 166px;
            }
        }
        .radioBox {
            margin-bottom: 15px;
            input {
                height: 30px;
                line-height: 30px;
            }
            .el-radio__label {
                display: inline;
            }

        }
    }
    .labelBlock {
        .el-form-item__label {
            display: block;;
            width: 100%;
        }
        .el-form-item__content {
            margin-left: 0 !important;
        }
    }

    .table_box {
        table {
            tbody {
                .el-input__inner {
                    border: none !important;
                }

            }

        }
    }
    .line_select {
        .el-form-item__content {
            display: flex;
        }
        .select_box {
            display: flex;
            .el-input__inner {
                padding-left: 3px;
                padding-right: 20px;

            }
            .el-input__suffix {
                right: 0;
                padding: 0;
                width: 28px;
            }
            span {
                font-size: 18px;
                color: #dedede;
                padding: 0 4px;
            }
        }

    }
  .el-radio__input .el-radio__inner{
    border-radius: 7px;

  }
  .el-radio__input input{
      border:none
  }
}
/depp/.btnGray{
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    display: inline-block;
    min-width: 124px;
    padding: 0 24px;
    line-height: 32px;
    height: 34px;
    text-align: center;
    background: #E0EBF2;
    -webkit-box-shadow: 0px 6px 6px 0px rgb(0 149 235 / 20%);
    box-shadow: 0px 6px 6px 0px rgb(0 149 235 / 20%);
    border: 1px solid #0699EE;
    border-radius: 15px;
    cursor: pointer;
    font-size: 18px;
    color: #15A3F5;
    font-weight: 500;
    -moz-user-select: none;
    -ms-user-select: none;
    -webkit-user-select: none;
    user-select: none;
}
</style>